"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var fabric_1 = require("fabric");
var constants_1 = require("../common/constants");
var image_loader_1 = require("./image-loader");
var fabric_2 = require("./fabric");
var ObjectImporter = /** @class */ (function () {
    function ObjectImporter() {
    }
    ObjectImporter.prototype.import = function (item, params) {
        return __awaiter(this, void 0, void 0, function () {
            var object, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = item.type;
                        switch (_a) {
                            case constants_1.LayerType.STATIC_TEXT: return [3 /*break*/, 1];
                            case constants_1.LayerType.STATIC_IMAGE: return [3 /*break*/, 3];
                            case constants_1.LayerType.BACKGROUND_IMAGE: return [3 /*break*/, 5];
                            case constants_1.LayerType.STATIC_VIDEO: return [3 /*break*/, 7];
                            case constants_1.LayerType.STATIC_VECTOR: return [3 /*break*/, 9];
                            case constants_1.LayerType.STATIC_PATH: return [3 /*break*/, 11];
                            case constants_1.LayerType.BACKGROUND: return [3 /*break*/, 13];
                            case constants_1.LayerType.GROUP: return [3 /*break*/, 15];
                        }
                        return [3 /*break*/, 17];
                    case 1: return [4 /*yield*/, this.staticText(item)];
                    case 2:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 3: return [4 /*yield*/, this.staticImage(item)];
                    case 4:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 5: return [4 /*yield*/, this.backgroundImage(item)];
                    case 6:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 7: return [4 /*yield*/, this.staticVideo(item)];
                    case 8:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 9: return [4 /*yield*/, this.staticVector(item)];
                    case 10:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 11: return [4 /*yield*/, this.staticPath(item)];
                    case 12:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 13: return [4 /*yield*/, this.background(item)];
                    case 14:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 15: return [4 /*yield*/, this.group(item, params)];
                    case 16:
                        object = _b.sent();
                        return [3 /*break*/, 17];
                    case 17: return [2 /*return*/, object];
                }
            });
        });
    };
    ObjectImporter.prototype.staticText = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                var baseOptions = _this.getBaseOptions(item);
                var metadata = item.metadata;
                var _a = item, textAlign = _a.textAlign, fontFamily = _a.fontFamily, fontSize = _a.fontSize, charSpacing = _a.charSpacing, lineHeight = _a.lineHeight, text = _a.text, underline = _a.underline, fill = _a.fill;
                var textOptions = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, baseOptions), { underline: underline, width: baseOptions.width ? baseOptions.width : 240, text: text ? text : "Empty Text", fill: fill ? fill : "#333333" }), (textAlign && { textAlign: textAlign })), (fontFamily && { fontFamily: fontFamily })), (fontSize && { fontSize: fontSize })), (charSpacing && { charSpacing: charSpacing })), (lineHeight && { lineHeight: lineHeight })), { metadata: metadata });
                // @ts-ignore
                var element = new fabric_1.fabric.StaticText(textOptions);
                (0, fabric_2.updateObjectShadow)(element, item.shadow);
                resolve(element);
            }
            catch (err) {
                reject(err);
            }
        });
    };
    ObjectImporter.prototype.staticImage = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, _a, src, cropX, cropY, image, element, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        baseOptions = this.getBaseOptions(item);
                        _a = item, src = _a.src, cropX = _a.cropX, cropY = _a.cropY;
                        return [4 /*yield*/, (0, image_loader_1.loadImageFromURL)(src)];
                    case 1:
                        image = _b.sent();
                        element = new fabric_1.fabric.StaticImage(image, __assign(__assign({}, baseOptions), { cropX: cropX || 0, cropY: cropY || 0 }));
                        (0, fabric_2.updateObjectShadow)(element, item.shadow);
                        resolve(element);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _b.sent();
                        reject(err_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    ObjectImporter.prototype.backgroundImage = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, _a, src, cropX, cropY, image, element, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        baseOptions = this.getBaseOptions(item);
                        _a = item, src = _a.src, cropX = _a.cropX, cropY = _a.cropY;
                        return [4 /*yield*/, (0, image_loader_1.loadImageFromURL)(src)];
                    case 1:
                        image = _b.sent();
                        element = new fabric_1.fabric.BackgroundImage(image, __assign(__assign({}, baseOptions), { cropX: cropX || 0, cropY: cropY || 0 }));
                        (0, fabric_2.updateObjectShadow)(element, item.shadow);
                        resolve(element);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _b.sent();
                        reject(err_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    ObjectImporter.prototype.staticVideo = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, _a, src, cropX, cropY, image, element, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        baseOptions = this.getBaseOptions(item);
                        _a = item, src = _a.preview, cropX = _a.cropX, cropY = _a.cropY;
                        return [4 /*yield*/, (0, image_loader_1.loadImageFromURL)(src)];
                    case 1:
                        image = _b.sent();
                        element = new fabric_1.fabric.StaticImage(image, __assign(__assign({}, baseOptions), { cropX: cropX || 0, cropY: cropY || 0 }));
                        (0, fabric_2.updateObjectShadow)(element, item.shadow);
                        resolve(element);
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _b.sent();
                        reject(err_3);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    ObjectImporter.prototype.staticPath = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, _a, path, fill, element;
            return __generator(this, function (_b) {
                try {
                    baseOptions = this.getBaseOptions(item);
                    _a = item, path = _a.path, fill = _a.fill;
                    element = new fabric_1.fabric.StaticPath(__assign(__assign({}, baseOptions), { 
                        // @ts-ignore
                        path: path, fill: fill }));
                    (0, fabric_2.updateObjectShadow)(element, item.shadow);
                    resolve(element);
                }
                catch (err) {
                    reject(err);
                }
                return [2 /*return*/];
            });
        }); });
    };
    ObjectImporter.prototype.group = function (item, params) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, objects, _a, _b, object, _c, _d, e_1_1, element, err_4;
            var e_1, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 9, , 10]);
                        baseOptions = this.getBaseOptions(item);
                        objects = [];
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        _a = __values(item.objects), _b = _a.next();
                        _f.label = 2;
                    case 2:
                        if (!!_b.done) return [3 /*break*/, 5];
                        object = _b.value;
                        _d = (_c = objects).concat;
                        return [4 /*yield*/, this.import(object, params)];
                    case 3:
                        objects = _d.apply(_c, [_f.sent()]);
                        _f.label = 4;
                    case 4:
                        _b = _a.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_b && !_b.done && (_e = _a.return)) _e.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        element = new fabric_1.fabric.Group(objects, baseOptions);
                        (0, fabric_2.updateObjectShadow)(element, item.shadow);
                        resolve(element);
                        return [3 /*break*/, 10];
                    case 9:
                        err_4 = _f.sent();
                        reject(err_4);
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        }); });
    };
    ObjectImporter.prototype.background = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions, fill, element;
            return __generator(this, function (_a) {
                try {
                    baseOptions = this.getBaseOptions(item);
                    fill = item.fill;
                    element = new fabric_1.fabric.Background(__assign(__assign({}, baseOptions), { fill: fill, id: "background", name: "" }));
                    resolve(element);
                }
                catch (err) {
                    reject(err);
                }
                return [2 /*return*/];
            });
        }); });
    };
    ObjectImporter.prototype.staticVector = function (item) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var baseOptions_1, _a, src_1, _b, colorMap_1;
            return __generator(this, function (_c) {
                try {
                    baseOptions_1 = this.getBaseOptions(item);
                    _a = item, src_1 = _a.src, _b = _a.colorMap, colorMap_1 = _b === void 0 ? {} : _b;
                    fabric_1.fabric.loadSVGFromURL(src_1, function (objects, opts) {
                        var width = baseOptions_1.width, height = baseOptions_1.height;
                        if (!width || !height) {
                            baseOptions_1.width = opts.width;
                            baseOptions_1.height = opts.height;
                        }
                        var element = new fabric_1.fabric.StaticVector(objects, opts, __assign(__assign({}, baseOptions_1), { src: src_1, colorMap: colorMap_1 }));
                        (0, fabric_2.updateObjectShadow)(element, item.shadow);
                        resolve(element);
                    });
                }
                catch (err) {
                    reject(err);
                }
                return [2 /*return*/];
            });
        }); });
    };
    ObjectImporter.prototype.getBaseOptions = function (item) {
        var id = item.id, name = item.name, left = item.left, top = item.top, width = item.width, height = item.height, scaleX = item.scaleX, scaleY = item.scaleY, opacity = item.opacity, flipX = item.flipX, flipY = item.flipY, skewX = item.skewX, skewY = item.skewY, stroke = item.stroke, strokeWidth = item.strokeWidth, originX = item.originX, originY = item.originY, angle = item.angle;
        var metadata = item.metadata ? item.metadata : {};
        var baseOptions = __assign(__assign({ id: id, name: name, angle: angle, top: top, left: left, width: width, height: height, originX: originX || "left", originY: originY || "top", scaleX: scaleX || 1, scaleY: scaleY || 1, opacity: opacity ? opacity : 1, flipX: flipX ? flipX : false, flipY: flipY ? flipY : false, skewX: skewX ? skewX : 0, skewY: skewY ? skewY : 0 }, (stroke && { stroke: stroke })), { strokeWidth: strokeWidth ? strokeWidth : 0, strokeDashArray: item.strokeDashArray ? item.strokeDashArray : null, strokeLineCap: item.strokeLineCap ? item.strokeLineCap : "butt", strokeLineJoin: item.strokeLineJoin ? item.strokeLineJoin : "miter", strokeUniform: item.strokeUniform || false, strokeMiterLimit: item.strokeMiterLimit ? item.strokeMiterLimit : 4, strokeDashOffset: item.strokeDashOffset ? item.strokeMiterLimit : 0, metadata: metadata });
        return baseOptions;
    };
    return ObjectImporter;
}());
exports.default = ObjectImporter;
//# sourceMappingURL=object-importer-render.js.map